<template>
  <UploadJson
    v-user-role-permission="['test']"
    @update="getAllList"
    :columnKey="columnKey"
    :articleKeys="articleKeys"
  >
    <div class="upload_voice_btn operation_btn test-btn">上传JSON</div>
  </UploadJson>
  <a
    v-user-role-permission="['test']"
    :href="exportFile(columnKey)"
    class="upload_voice_btn operation_btn test-btn"
  >
    导出JSON
  </a>
  <a
    v-user-role-permission="['test']"
    :href="exportTxtFile(columnKey)"
    class="upload_voice_btn operation_btn test-btn"
  >
    导出TXT
  </a>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue';
import UploadJson from '@/components/Upload/UploadJson.vue';
import { exportFile, exportTxtFile } from '@/components/Upload/methods/uploadAction';

const emits = defineEmits(['getAllList', 'update']);
defineProps({
  columnKey: String,
  articleKeys: Array,
});
function getAllList() {
  emits('getAllList');
}
</script>
